import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle (event) {
    const expires = new Date(Date.now() + 365 * 864e5).toUTCString()
    document.cookie = `allow_cookies=${event.params.allow}; expires=${expires}`
    if (event.params.allow) this.element.outerHTML = ""
  }
}
